/********************************************
 UWANT GLOBAL JAVASCRIPT
 Panasonic-style Navigation
 Author: Alex (2025)
*********************************************/


/* ============================================================
   DESKTOP NAV — Megamenu Hover Behavior
============================================================ */
document.querySelectorAll('[data-uwant-nav-item]').forEach(item => {
  let timer;

  item.addEventListener('mouseenter', () => {
    clearTimeout(timer);

    // 关闭其他菜单
    document.querySelectorAll('[data-uwant-mega]').forEach(m => {
      if (m !== item.querySelector('[data-uwant-mega]')) {
        m.classList.remove('active');
      }
    });

    const mega = item.querySelector('[data-uwant-mega]');
    if (mega) mega.classList.add('active');
  });

  item.addEventListener('mouseleave', () => {
    const mega = item.querySelector('[data-uwant-mega]');
    if (!mega) return;

    timer = setTimeout(() => {
      mega.classList.remove('active');
    }, 200);
  });
});


/* ============================================================
   CLICK OUTSIDE TO CLOSE MEGAMENU
============================================================ */
document.addEventListener('click', (e) => {
  const nav = document.getElementById('uwant-nav');
  if (!nav.contains(e.target)) {
    document.querySelectorAll('[data-uwant-mega]').forEach(m => {
      m.classList.remove('active');
    });
  }
});


/* ============================================================
   MOBILE MENU — OPEN
============================================================ */
const mobileMenu = document.querySelector('[data-uwant-mobile-menu]');
const mobileOpenBtn = document.querySelector('[data-uwant-mobile-open]');
const mobileCloseBtn = document.querySelector('[data-uwant-mobile-close]');

if (mobileOpenBtn) {
  mobileOpenBtn.addEventListener('click', () => {
    mobileMenu.classList.add('active');
    document.body.style.overflow = "hidden"; // 禁止滚动
  });
}


/* ============================================================
   MOBILE MENU — CLOSE
============================================================ */
if (mobileCloseBtn) {
  mobileCloseBtn.addEventListener('click', () => {
    mobileMenu.classList.remove('active');
    document.body.style.overflow = "";
  });
}


/* ============================================================
   MOBILE ACCORDION（折叠二级菜单）
============================================================ */
document.querySelectorAll('[data-uwant-mobile-parent]').forEach(btn => {

  btn.addEventListener('click', () => {
    const content = btn.nextElementSibling;

    if (!content) return;

    // 如果已展开 → 收起
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      btn.classList.remove('open');
      return;
    }

    // 收起其他
    document.querySelectorAll('[data-uwant-mobile-sub]').forEach(sub => {
      if (sub !== content) sub.style.maxHeight = null;
    });
    document.querySelectorAll('[data-uwant-mobile-parent]').forEach(b => {
      if (b !== btn) b.classList.remove('open');
    });

    // 展开当前
    content.style.maxHeight = content.scrollHeight + "px";
    btn.classList.add('open');
  });

});


/* ============================================================
   CLICK OUTSIDE TO CLOSE MOBILE MENU
============================================================ */
document.addEventListener('click', (e) => {
  if (
    mobileMenu &&
    mobileMenu.classList.contains('active') &&
    !mobileMenu.contains(e.target) &&
    !e.target.closest('[data-uwant-mobile-open]')
  ) {
    mobileMenu.classList.remove('active');
    document.body.style.overflow = "";
  }
});



/* ============================================================
   UWANT HERO CAROUSEL — Panasonic Style
   JS Module (Auto play + Progress + Controls)
   Author: Alex
============================================================ */

document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".uwant-hero-carousel");
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const slider = carousel.querySelector(".uwant-hero-slider");
    const slides = carousel.querySelectorAll(".uwant-hero-slide");
    const indicators = carousel.querySelectorAll(".uwant-hero-indicator");
    const btnPrev = carousel.querySelector(".uwant-hero-prev");
    const btnNext = carousel.querySelector(".uwant-hero-next");
    const btnPause = carousel.querySelector(".uwant-hero-play-pause");

    let current = 0;
    const total = slides.length;
    let autoPlay = true;
    let intervalTime = 5000;
    let autoTimer;

    /* -----------------------------
       更新 Slider 位置
    ----------------------------- */
    function goToSlide(index) {
      current = (index + total) % total;
      slider.style.transform = `translateX(-${current * 100}%)`;
      updateIndicators();
    }

    /* -----------------------------
       进度条激活
    ----------------------------- */
    function updateIndicators() {
      indicators.forEach((dot, i) => {
        dot.classList.remove("active");
        if (i === current) {
          dot.classList.add("active");
        }
      });
    }

    /* -----------------------------
       下一张
    ----------------------------- */
    function nextSlide() {
      goToSlide(current + 1);
    }

    /* -----------------------------
       上一张
    ----------------------------- */
    function prevSlide() {
      goToSlide(current - 1);
    }

    /* -----------------------------
       自动播放启动
    ----------------------------- */
    function startAutoPlay() {
      stopAutoPlay();
      autoTimer = setInterval(nextSlide, intervalTime);
      btnPause.textContent = "❚❚"; // pause icon
      autoPlay = true;
      updateIndicators();
    }

    /* -----------------------------
       自动播放暂停
    ----------------------------- */
    function stopAutoPlay() {
      clearInterval(autoTimer);
      btnPause.textContent = "▶"; // play icon
      autoPlay = false;

      indicators.forEach((dot) => {
        dot.style.animation = "none";
        void dot.offsetWidth; // 强制重绘，重置动画
      });
    }

    /* -----------------------------
       暂停/播放按钮
    ----------------------------- */
    btnPause.addEventListener("click", () => {
      if (autoPlay) {
        stopAutoPlay();
      } else {
        startAutoPlay();
      }
    });

    /* -----------------------------
       左右切换
    ----------------------------- */
    btnNext.addEventListener("click", () => {
      nextSlide();
      if (autoPlay) startAutoPlay();
    });

    btnPrev.addEventListener("click", () => {
      prevSlide();
      if (autoPlay) startAutoPlay();
    });

    /* -----------------------------
       初始化
    ----------------------------- */
    goToSlide(0);
    startAutoPlay();
  });
});


 







/* ==========================================================
   UWANT — Vimeo 视频模块 JS
========================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const covers = document.querySelectorAll("[data-open-vimeo]");
  
  covers.forEach(cover => {
    const id = cover.getAttribute("data-open-vimeo");
    const popup = document.getElementById("vimeo-popup-" + id);
    const closeBtn = document.querySelector("[data-close-vimeo='" + id + "']");
    const iframe = document.getElementById("vimeo-iframe-" + id);

    const vimeoId = "{{ section.settings.vimeo_id }}";  
    const vimeoSrc = "https://player.vimeo.com/video/" + vimeoId + "?autoplay=1&muted=0";

    /* 打开 */
    cover.addEventListener("click", () => {
      popup.style.display = "flex";
      iframe.src = vimeoSrc;
    });

    /* 关闭按钮 */
    closeBtn.addEventListener("click", () => {
      popup.style.display = "none";
      iframe.src = "";
    });

    /* 点击遮罩区域关闭 */
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        popup.style.display = "none";
        iframe.src = "";
      }
    });
  });
});

/* ==========================================================
   UWANT — Vimeo 视频模块 JS（自动解析链接）
========================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const covers = document.querySelectorAll("[data-open-vimeo]");

  covers.forEach(cover => {
    const id = cover.getAttribute("data-open-vimeo");
    const popup = document.getElementById("vimeo-popup-" + id);
    const closeBtn = document.querySelector("[data-close-vimeo='" + id + "']");
    const iframe = document.getElementById("vimeo-iframe-" + id);

    // 获取用户输入
    let rawInput = "{{ section.settings.vimeo_id }}".trim();

    // ① 如果用户填的是纯数字
    let vimeoId = rawInput;

    // ② 如果用户填的是 URL → 提取数字 ID
    const match = rawInput.match(/(\d{7,12})/);
    if (match) {
      vimeoId = match[1];
    }

    const vimeoSrc = "https://player.vimeo.com/video/" + vimeoId + "?autoplay=1&muted=0";

    /* 打开 */
    cover.addEventListener("click", () => {
      popup.style.display = "flex";
      iframe.src = vimeoSrc;
    });

    /* 关闭 */
    closeBtn.addEventListener("click", () => {
      popup.style.display = "none";
      iframe.src = "";
    });

    /* 点击遮罩关闭 */
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        popup.style.display = "none";
        iframe.src = "";
      }
    });
  });
});


/* ============================
   UWANT Scenes JS Hook
   ============================ */
document.addEventListener("DOMContentLoaded", () => {
  console.log("UWANT Scenes Module Loaded");
});




document.addEventListener('DOMContentLoaded', function () {
  // 查找所有 uwant-tabs-section（支持添加多个同类模块）
  document.querySelectorAll('.uwant-tabs-section').forEach(function(section){
    
    var navItems = section.querySelectorAll('.uwant-tab-nav-item');
    var panels   = section.querySelectorAll('.uwant-tab-panel');
    var prevBtn  = section.querySelector('.uwant-tabs-arrow.prev');
    var nextBtn  = section.querySelector('.uwant-tabs-arrow.next');
    var scrollBox = section.querySelector('.uwant-tabs-scroll');
    
    var activeIndex = 0;

    if (navItems.length === 0) return;

    function setActive(index) {
      if (index < 0 || index >= navItems.length) return;
      activeIndex = index;

      navItems.forEach(function(item, i){
        item.classList.toggle('is-active', i === index);
      });

      panels.forEach(function(panel, i){
        panel.classList.toggle('is-active', i === index);
      });

      updateArrowState();
      scrollToCenter(index);
    }

    function updateArrowState(){
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = activeIndex === 0;
      nextBtn.disabled = activeIndex === navItems.length - 1;
    }

    function scrollToCenter(index){
      if (!scrollBox) return;

      var target = navItems[index];
      if (!target) return;

      var scrollRect = scrollBox.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();

      var offset = (targetRect.left + targetRect.width / 2)
                 - (scrollRect.left + scrollRect.width / 2);

      scrollBox.scrollBy({
        left: offset,
        behavior: 'smooth'
      });
    }

    // click
    navItems.forEach(function(item, index){
      item.addEventListener('click', function(){
        setActive(index);
      });
    });

    // arrows
    if (prevBtn){
      prevBtn.addEventListener('click', function(){
        setActive(activeIndex - 1);
      });
    }
    if (nextBtn){
      nextBtn.addEventListener('click', function(){
        setActive(activeIndex + 1);
      });
    }

    // 初始化
    setActive(0);
  });
});


 /* 页脚手机控制 */

 
document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll("[data-footer-toggle]");
  titles.forEach(function (title) {
    title.addEventListener("click", function () {
      this.parentNode.classList.toggle("active");
    });
  });
});






/* B400详情 */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".uwant-product-detail-v2").forEach(section => {
    const slider = section.querySelector(".media-slider");
    const slides = section.querySelectorAll(".slide");
    const prevBtn = section.querySelector(".prev");
    const nextBtn = section.querySelector(".next");
    const dotsContainer = section.querySelector(".dots");
    const tabBtns = section.querySelectorAll(".tab-btn");
    const videoSlide = section.querySelector(".video-slide");
    let index = 0;

    // 初始化小圆点
    dotsContainer.innerHTML = "";
    slides.forEach((_, i) => {
      const dot = document.createElement("span");
      dot.addEventListener("click", () => {
        index = i;
        updateSlide();
      });
      dotsContainer.appendChild(dot);
    });
    const dots = dotsContainer.querySelectorAll("span");
    dots[0]?.classList.add("active");

    // 更新轮播图显示
    function updateSlide() {
      slider.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, i) => dot.classList.toggle("active", i === index));
    }

    // 左右箭头点击事件
    nextBtn?.addEventListener("click", () => {
      index = (index + 1) % slides.length;
      updateSlide();
    });
    prevBtn?.addEventListener("click", () => {
      index = (index - 1 + slides.length) % slides.length;
      updateSlide();
    });

    // ✅ がぞう / ビデオ 切换逻辑增强版
    tabBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        const type = btn.dataset.type;

        // 更新按钮样式
        tabBtns.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        // 切换内容
        if (type === "photo") {
          index = 0;
          updateSlide();
        } else if (type === "video") {
          index = slides.length - 1;
          updateSlide();

          // 自动播放视频
          const video = videoSlide?.querySelector("video");
          if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        }
      });
    });
  });

  // ✅ 数量加减功能修复
  document.querySelectorAll('.uwant-checkout').forEach(card => {
    const minus = card.querySelector('.qty-minus');
    const plus = card.querySelector('.qty-plus');
    const input = card.querySelector('input[name="quantity"]');
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', () => {
      let val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });

    plus.addEventListener('click', () => {
      let val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });
});




// =======================
// 🔍 点击主图 = 放大查看
// =======================
const lightbox = document.getElementById("uwant-lightbox");
const lightboxImg = document.querySelector(".uwant-lightbox-img");
const lbPrev = document.querySelector(".uwant-lightbox-prev");
const lbNext = document.querySelector(".uwant-lightbox-next");
const lbClose = document.querySelector(".uwant-lightbox-close");

let lbIndex = 0;
let lbImages = [];

document.querySelectorAll(".media-slider .slide img").forEach((img, i) => {
  lbImages.push(img.src);

  img.addEventListener("click", () => {
    lbIndex = i;
    lightboxImg.src = lbImages[lbIndex];
    lightbox.style.display = "flex";
  });
});

lbClose.addEventListener("click", () => {
  lightbox.style.display = "none";
});

lbPrev.addEventListener("click", () => {
  lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length;
  lightboxImg.src = lbImages[lbIndex];
});

lbNext.addEventListener("click", () => {
  lbIndex = (lbIndex + 1) % lbImages.length;
  lightboxImg.src = lbImages[lbIndex];
});

// 手机端滑动关闭
lightbox.addEventListener("click", e => {
  if (e.target === lightbox) lightbox.style.display = "none";
});





/* =========================================================
   UWANT GLOBAL JS (Pro Master Version)
   Full single-file version
   Author: Alex
========================================================= */


/* =========================================================
   1. Intersection Observer — Fade-in Animations
   进入画面自动淡入（默认开启）
========================================================= */

document.addEventListener("DOMContentLoaded", () => {
  const fadeItems = document.querySelectorAll(".sb-block");

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("sb-fade-in");
      }
    });
  }, { threshold: 0.2 });

  fadeItems.forEach(el => io.observe(el));
});


/* =========================================================
   2. Lazyload Enhance（懒加载强化）
   避免极端情况下图片不加载
========================================================= */

document.addEventListener("DOMContentLoaded", () => {
  const imgs = document.querySelectorAll("img[loading='lazy']");

  imgs.forEach(img => {
    img.addEventListener("error", () => {
      img.loading = "eager"; // fallback 强制加载
    });
  });
});


/* =========================================================
   3. Smooth Scroll (平滑滚动)
   用于任意 data-scroll="#id"
========================================================= */

document.addEventListener("click", (e) => {
  const target = e.target.closest("[data-scroll]");
  if (!target) return;

  const id = target.getAttribute("data-scroll");
  const el = document.querySelector(id);
  if (!el) return;

  e.preventDefault();
  window.scrollTo({
    top: el.offsetTop - 80,
    behavior: "smooth"
  });
});


/* =========================================================
   4. Sticky Header Compatibility（默认关闭）
========================================================= */

(function() {
  const enableSticky = false; // 需要时改成 true

  if (!enableSticky) return;

  const header = document.querySelector(".uwant-header");
  if (!header) return;

  let lastY = window.scrollY;

  window.addEventListener("scroll", () => {
    const currentY = window.scrollY;

    if (currentY > lastY && currentY > 80) {
      header.classList.add("header-hidden");
    } else {
      header.classList.remove("header-hidden");
    }

    lastY = currentY;
  });
})();


/* =========================================================
   5. Future Animation API（未来可扩展动画）
   调用示例：
   UWANT.animate(".class", "fade-up", 0.2);
========================================================= */

window.UWANT = {
  animate(selector, animation = "fade-up", threshold = 0.2) {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add(`uwant-${animation}`);
        }
      });
    }, { threshold });

    elements.forEach(el => io.observe(el));
  }
};




/* ==========================================================
   GUIDE FAQ JS
   File: guide-faq.liquid
   Simple toggle FAQ items
========================================================== */

document.addEventListener("click", function(e) {
  const faqItem = e.target.closest(".guide-faq-item");
  if (!faqItem) return;

  faqItem.classList.toggle("active");
});




/* ============================================================
   SEARCH OVERLAY — OPEN / CLOSE
============================================================ */

// 选择元素
const searchOpenBtn = document.querySelector("[data-uwant-search-open]");
const searchOverlay = document.querySelector("[data-uwant-search-overlay]");
const searchCloseBtn = document.querySelector("[data-uwant-search-close]");

// 打开搜索
if (searchOpenBtn && searchOverlay) {
  searchOpenBtn.addEventListener("click", () => {
    searchOverlay.classList.add("active");
    document.body.style.overflow = "hidden";
  });
}

// 关闭搜索（关闭按钮）
if (searchCloseBtn && searchOverlay) {
  searchCloseBtn.addEventListener("click", () => {
    searchOverlay.classList.remove("active");
    document.body.style.overflow = "";
  });
}

// 点击遮罩关闭
if (searchOverlay) {
  searchOverlay.addEventListener("click", (e) => {
    if (e.target === searchOverlay) {
      searchOverlay.classList.remove("active");
      document.body.style.overflow = "";
    }
  });
}


